import React from 'react';
import { s } from "../../Style.jsx";

const Categories = ({ categories, setCategories, setSelectedCategoryIndex, text = "Menu" }) => {

    return <>

        <h3 style={s.title3}>{text}s</h3>

        <div style={s.box}>

            <div style={s.table}>

                {(categories || []).map((category, i) => <div key={i} style={s.cell(i)}>

                    <div style={s.rowLeft} onClick={() => setSelectedCategoryIndex(i)}>
                        <span style={s.input}>{category.name || "New Category"}</span>
                    </div>

                    <div style={{...s.rowLeft, width: 80 }}>
                        {i > 0 && <i className="fas fa-arrow-up" style={s.icon}
                            onClick={() => setCategories(categories.map((c, j) => j === i ? categories[i - 1] : j === i - 1 ? categories[i] : c))}></i>}
                        {i < categories.length - 1 && <i className="fas fa-arrow-down" style={s.icon}
                            onClick={() => setCategories(categories.map((c, j) => j === i ? categories[i + 1] : j === i + 1 ? categories[i] : c))}></i>}
                    </div>

                </div>)}

            </div>

            <button onClick={() => setCategories([...categories, { name: "" }])}>Add {text}</button>

        </div>

    </>;

}

export default Categories;